<template>
  <nav
    id="primarybar"
    class="is-flex is-align-items-center has-background-primary has-text-colour-white gap-2 px-2 sm:px-5"
    data-test="navbar-desktop-topbar"
    :aria-label="$t('navbar.landmarks.employee.client.primary')"
  >
    <div class="is-flex-grow-1 is-flex is-align-items-center">
      <div
        v-if="mq.isDesktop"
        class="is-flex gap-3"
      >
        <AppLink
          :to="{ name: ROUTES_EMPLOYEES.CLIENT_DASHBOARD }"
          :aria-label="$t('client.labels.zigguHome')"
          :title="$t('client.labels.zigguHome')"
        >
          <img
            class="h-[20px]"
            :src="ziggu_logo"
            :alt="$t('client.labels.zigguHome')"
          />
        </AppLink>
        <NavbarItemHorizontal
          v-for="(item, idx) in NAVBAR_ITEMS_EMPLOYEES_CLIENT"
          :key="idx"
          :is_primary_navbar="true"
          :item="item"
          :params="item.route_params"
          @openProjectSideBar="show_project_sidebar = !show_project_sidebar"
        />
      </div>
      <div
        v-else
        class="is-flex cursor-pointer self-center text-white hover:text-slate-100"
      >
        <div
          class="is-flex is-align-items-center"
          data-test="employee-navbar-burger-menu"
          @click="toggle"
        >
          <FontAwesomeIcon
            class="self-center"
            :icon="['far', 'bars']"
            size="lg"
          />
        </div>

        <PMenu
          id="overlay_menu"
          ref="menu"
          :model="NAVBAR_ITEMS_EMPLOYEES_CLIENT"
          :popup="true"
        >
          <template #item="{ item, props }">
            <NavbarItemHorizontal
              v-bind="props.action"
              :item="item"
              :params="item.route_params"
              @openProjectSideBar="show_project_sidebar = !show_project_sidebar"
            />
          </template>
        </PMenu>
        <AppLink
          :to="{ name: ROUTES_EMPLOYEES.CLIENT_DASHBOARD }"
          class="ml-2 sm:ml-3"
          :aria-label="$t('client.labels.zigguHome')"
          :title="$t('client.labels.zigguHome')"
        >
          <img
            class="mr-5 hidden min-[370px]:block"
            :src="ziggu_logo"
            :alt="$t('client.labels.zigguHome')"
            style="height: 20px"
          />
          <img
            class="mr-5 block min-[370px]:hidden"
            :src="ziggu_logo_small"
            style="height: 20px"
          />
        </AppLink>
      </div>
    </div>

    <div class="flex items-center gap-3">
    <AppLink
        v-if="current_client.attributes.ooo"
        v-tooltip.bottom="$t('client.labels.warningooo')"
        class="notification is-danger has-text-weight-bold mb-0 block cursor-pointer p-1 px-2"
        :to="{ name: ROUTES_EMPLOYEES.CLIENT_COMPANY, hash: '#ooo' }"
      >
        <span class="hidden min-[1100px]:inline">{{ $t('client.labels.warningooo') }}</span>
        <FontAwesomeIcon
          class="inline min-[1100px]:hidden"
          :icon="['fas', 'building-circle-xmark']"
          size="xl"
        />
      </AppLink>
      <div
        v-tooltip.bottom="$t('client.labels.contactZiggu')"
        class="relative cursor-pointer text-sm text-white"
        @click="openIntercom"
      >
        <span class="hidden sm:inline">{{ $t('client.labels.chatWithUs') }}</span>
        <FontAwesomeIcon
          class="inline sm:hidden"
          :icon="['far', 'comment']"
          size="lg"
        />
      </div>
      <HelpSidebar />
      <TheClientSettingsNavbar />
      <NotificationsToggleIcon />
      <ProfileDropdown />
    </div>

    <TheProjectSideBar
      :show_project_sidebar="show_project_sidebar"
      @closeProjectSidebar="show_project_sidebar = false"
    />
  </nav>
</template>

<script>
import TheClientSettingsNavbar from '@/app/shared_components/navbar/TheClientSettingsNavbar.vue';
import HelpSidebar from '@/app/shared_components/navbar/TheHelpSidebar.vue';
import NotificationsToggleIcon from '@/app/shared_components/navbar/notifications/TheNotificationsToggleIcon.vue';
import ProfileDropdown from '@/app/shared_components/navbar/TheProfileDropdown.vue';
import { useMqService } from '@/plugins/mq';
import { NAVBAR_ITEMS_EMPLOYEES_CLIENT } from '@/app/data/navbar_constants';
import NavbarItemHorizontal from '@/app/shared_components/navbar/NavbarItemHorizontal.vue';
import TheProjectSideBar from '@/app/_employees/components/sidebars/TheProjectSideBar.vue';
import ziggu_logo from '@/assets/images/Ziggu_Logo_White.png';
import ziggu_logo_small from '@/assets/images/Ziggu_Logo_White_Small.png';
import { ROUTES_EMPLOYEE_OVERVIEWS, ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import { mapGetters } from 'vuex';

export default {
  name: 'TheNavbarDesktopClientHorizontal',
  components: {
    HelpSidebar,
    NotificationsToggleIcon,
    ProfileDropdown,
    NavbarItemHorizontal,
    TheClientSettingsNavbar,
    TheProjectSideBar,
  },

  setup() {
    const mq = useMqService();
    return { mq };
  },

  data() {
    return {
      ziggu_logo,
      ziggu_logo_small,
      show_project_sidebar: false,
      NAVBAR_ITEMS_EMPLOYEES_CLIENT,
    };
  },

  computed: {
    ...mapGetters(['current_client']),
    ROUTES_EMPLOYEES() {
      return ROUTES_EMPLOYEES;
    },
  },

  created() {
    this.NAVBAR_ITEMS_EMPLOYEES_CLIENT = this.NAVBAR_ITEMS_EMPLOYEES_CLIENT.filter(
      (item) => item.name !== ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_CONVERSATIONS,
    );
  },
  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    openIntercom() {
      window.Intercom?.('show');
    },
  },
};
</script>
